import http from '@monolith/legacy/services/api/http';

export const validatePromoCode = async (code: string) => {
  const result = await http().get(`/api/lift-code/${code}`);
  return result?.data?.data;
};
